<template>
    <div>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                    small
                    text
                    class="primary"
                    @click.stop="dialog = true"
                    v-on="on"
                >Reply
                </v-btn>
            </template>
            <span>Reply</span>
        </v-tooltip>

        <v-dialog width="600px" v-model="dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">Add Reply to News Feed</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="form"
                                v-model="valid"
                                validation>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                name="Reply Content"
                                                label="Reply Content*"
                                                outlined
                                                v-model="replyContent"
                                                :rules="replyContentRules"
                                        ></v-text-field>
                                    </v-col>
                                </v-flex>
                            </v-layout>

                            <div class="d-flex justify-center">
                                <v-btn
                                        color="primary"
                                        depressed
                                        class="mr-4"
                                        :disabled="!valid || localLoading"
                                        @click="submit"
                                        :loading="localLoading"
                                ><v-icon left>mdi-publish</v-icon>Publish</v-btn>
                                <v-btn
                                        color="warning"
                                        depressed
                                        @click="cancel"
                                        :loading="localLoading"
                                ><v-icon left>mdi-cancel</v-icon>Clear</v-btn>
                            </div>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "AddReplyModal",
        props: ['thisPostData'],
        data(){
            return{
                dialog: false,
                postData: null,
                replyContent: '',
                valid: false,
                localLoading: false,
                replyContentRules: [
                    v => !!v || 'Please enter Reply content',
                ],
            }
        },
        computed: {
            user(){
                return JSON.parse(localStorage.getItem('user'));
            },
        },
        methods: {
            submit () {
                if (this.$refs.form.validate()) {
                    this.localLoading = true;

                    const newReply = {
                        reply_content: this.replyContent,
                        new_id: this.thisPostData.id,
                        // user_id: user.id
                    };

                    this.$store.dispatch('createNewReply', newReply).then(() => {
                    }).finally(() => {
                        this.replyContent = '';
                        this.localLoading = false;
                        this.dialog = false;
                    })
                }
            },
            cancel(){
                this.replyContent = '';
                this.dialog = false;
            },
        }
    }
</script>

<style scoped>

</style>